import React from 'react';
import {Link} from 'react-router-dom';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSpinner} from '@fortawesome/free-solid-svg-icons';

import Authenticated from 'Components/Layouts/Authenticated';
import {Alert, Loading} from 'Components/Partials';
import {Textarea, Radio, RenderWYSIWYG} from 'Components/Form';
import {ModalTrigger} from 'Components/Modal';
import {PrimaryButton} from 'Components/Button';

import Carousel from './Carousel';
import Book from './Book';

import UpdateExhibitor from './UpdateExhibitor';
import UpdateBookingItem from './UpdateBookingItem';
import UpdateCarouselItem from './UpdateCarouselItem';
import UpdateDownload from './UpdateDownload';
import UpdateQuizQuestion from './UpdateQuizQuestion';

import ExhibitorApi from 'Services/Api/Exhibitor/Exhibitor';
import MessageApi from 'Services/Api/Exhibitor/Message';
import QuizSubmissionApi from 'Services/Api/Exhibitor/QuizSubmission';
import User from 'Services/User';
import {translation} from 'Services/TranslationHelpers';
import {asset} from 'Services/BaseHelpers';
import ViewBookings from "Pages/Exhibitors/ViewBookings";
import DarkButton from "Components/Button/DarkButton";
import VideoCarousel from "Pages/Exhibitors/VideoCarousel";

export default class ExhibitorShow extends React.Component {
    /**
     * @var state
     */
    state = {
        editor: (User?.data?.is_admin || User?.data?.exhibitor_id === this.props.match.params.exhibitorId),
        loading: true,
        quiz_alert: null,
        message_alert: null,
        quiz_working: false,
        message_working: false,
        booking_working: false,
        quiz_answer: null,
        message: "",
        exhibitor: null,
    };

    /**
     * @method componentDidMount
     * @return {Promise<void>}
     */
    componentDidMount() {
        this.fetchExhibitor();
    };

    /**
     * @method fetchExhibitor
     * @return {Promise<void>}
     */
    fetchExhibitor = async () => {
        let exhibitorId = this.props.match.params.exhibitorId;

        const response = await ExhibitorApi.getExhibitor(exhibitorId);

        this.setState({
            loading: false,
            exhibitor: response.data.data,
        });
    };

    /**
     * @method sendMessage
     * @return {Promise<void>}
     */
    sendMessage = async () => {
        const {message, message_working, exhibitor} = this.state;

        if (message !== "" && message_working === false) {
            this.setState({ message_working: true });

            const response = await MessageApi.post(null, {
                message,
                exhibitor_id: exhibitor.id
            });

            if (response.status !== 201) {
                this.setState({
                    message_working: false,
                    message_alert: {
                        type: 'error',
                        message: response.message,
                        errors: response.errors
                    }
                });
                return;
            }

            this.setState({
                message_working: false,
                message: "",
                message_alert: {
                    type: 'success',
                    message: translation('exhibitors', 'message_submitted')
                }
            });
        }
    }

    /**
     * @method submitQuizAnswer
     * @param {string} question_id
     * @param {integer} answer_key
     * @return {Promise<void>}
     */
    submitQuizAnswer = async (question_id, answer_key) => {
        const {quiz_working} = this.state;

        if (question_id && answer_key && quiz_working === false) {
            this.setState({ quiz_working: true });

            const response = await QuizSubmissionApi.post(null, {
                exhibitor_quiz_question_id: question_id,
                answer: answer_key
            });

            if (response.status !== 201) {
                this.setState({
                    quiz_working: false,
                    quiz_alert: {
                        type: 'error',
                        message: response.message,
                        errors: response.errors
                    }
                });
                return;
            }

            this.setState({
                quiz_working: false,
                quiz_alert: {
                    type: 'success',
                    message: response.data.correct ?
                        translation('exhibitors', 'quiz_submitted_correct') :
                        translation('exhibitors', 'quiz_submitted_incorrect')
                }
            });
        }
    }

    /**
     *
     * @returns {React.JSX.Element|null}
     */
    renderVideoCarousel() {
        const { exhibitor } = this.state;
        const videos = [exhibitor.video, exhibitor.video_two, exhibitor.video_three, exhibitor.video_four].filter(Boolean);

        if (videos.length > 0) {
            return (
                <div className="my-12 w-full md:w-full mx-auto">
                <VideoCarousel videos={videos} perPage={1} arrowColour="text-light-blue-700" />
            </div>
            );
        }

        return null;
    }

    /**
     * @method render
     * @return {*}
     */
    render() {
        const {loading, exhibitor} = this.state;

        return (
            <Authenticated title="Exhibitos" titleText={exhibitor?.name ?? ''} headerImage={'/images/headers/brand.jpg'}>
                <div className="p-4 pb-12 text-center mx-auto text-app-blue max-w-6xl">

                    {loading && (<Loading/>)}

                    {!loading &&
                        <div>
                            { this.renderTopBar () }
                            <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
                                 <img
                                     src={ exhibitor?.logo?.url }
                                     className="w-full max-w-xs object-cover  mx-auto col-span-12"
                                 />
                                <div className="w-full mx-auto col-span-12 md:col-span-5">
                                    <div className="flex flex-col justify-center items-center">
                                        <div className="mb-8 w-full bg-app-light-green text-white text-left p-5 mx-auto">
                                            <p className="font-bold mb-4">
                                                Contact Details
                                            </p>

                                            <p className={ "mb-4" }>
                                                Contact Name: { exhibitor.contact_name }
                                            </p>

                                            <p className={ "mb-4" }>
                                                Email: <a
                                                href={ 'mailto:' + exhibitor.email }
                                                className={ "cursor-pointer underline" }
                                            >{ exhibitor.email }</a>
                                            </p>

                                            { exhibitor.telephone &&
                                                <p className={ "mb-4" }>
                                                    Telephone: <a
                                                    href={ 'tel:' + exhibitor.telephone }
                                                    className={ "underline cursor-pointer" }
                                                >{ exhibitor.telephone }</a>
                                                </p>
                                            }

                                            { exhibitor.website &&
                                                <p className={ "mb-4" }>
                                                    Website: <a
                                                    href={ exhibitor.website }
                                                    target="_blank"
                                                    className={ "cursor-pointer underline" }
                                                >{ exhibitor.website }</a>
                                                </p>
                                            }

                                            { exhibitor.linkedin &&
                                                <p>
                                                    LinkedIn: <a
                                                    href={ exhibitor.linkedin }
                                                    target="_blank"
                                                    className={ "cursor-pointer underline" }
                                                >{ exhibitor.linkedin }</a>
                                                </p>
                                            }

                                        </div>
                                    </div>

                                    {this.renderDownloadsArea()}
                                </div>
                                <div className="w-full mx-auto h-full col-span-12 md:col-span-7">
                                    <div className="flex flex-col text-left h-full">
                                        <div className=" text-left">
                                            <RenderWYSIWYG content={ exhibitor.blurb } />
                                        </div>

                                        { this.renderBookingArea () }
                                    </div>
                                </div>
                            </div>

                            {this.renderVideoCarousel()}

                            {/*<div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-12 mt-16">*/}
                            {/*    <div className="w-full mx-auto col-span-12 md:col-span-7">*/}
                            {/*        <div className="flex flex-col">*/}
                            {/*            <div className="text-left">*/}
                            {/*                <RenderWYSIWYG content={ exhibitor.download_blurb } />*/}
                            {/*            </div>*/}
                            {/*        </div>*/}
                            {/*    </div>*/}
                            {/*    <div className="w-full mx-auto col-span-12 md:col-span-5">*/}
                            {/*        <div className="flex flex-col justify-center items-center text-left">*/}
                            {/*           {this.renderDownloadsArea()}*/}
                            {/*        </div>*/}
                            {/*    </div>*/}
                            {/*</div>*/}

                            { this.renderQuizArea () }
                            {this.renderLogoBannerBlurbVideo()}
                            { this.renderCarousel () }

                            {/*<div className="flex flex-wrap flex-row justify-center gap-6 mt-8 mx-auto">*/}
                            {/*    { this.renderTalkArea () }*/}
                            {/*    { this.renderDownloadsArea () }*/}
                            {/*</div>*/}
                        </div>
                    }
                </div>
            </Authenticated>
        );
    }

    /**
     * @method renderTopBar
     * @return {*}
     */
    renderTopBar() {
        const { editor, exhibitor } = this.state;

        return (
            <div className="mb-8">
                { !User?.data?.exhibitor_id &&
                    <Link
                        className="uppercase font-bold text-light-blue-700 transition duration-200"
                        to="/exhibitors"
                    >
                        { translation ( 'exhibitors', 'back_to_exhibitors' ) }
                    </Link>
                }

                { ( User?.data?.is_admin || User?.data?.exhibitor_id === this.props.match.params.exhibitorId ) &&
                    <div className="py-4">
                        <PrimaryButton
                            text={ editor ? 'Preview My Stand' : 'Edit My Stand' }
                            onClick={ () => this.setState ( { editor: !editor } ) }
                            className="uppercase"
                        />
                    </div>
                }
            </div>
        );
    }

    /**
     * @method renderLogoBannerBlurbVideo
     * @return {*}
     */
    renderLogoBannerBlurbVideo() {
        const { editor, exhibitor } = this.state;

        return (
            <>
                <ModalTrigger
                    component={ UpdateExhibitor }
                    disabled={ !editor }
                    props={ {
                        exhibitor: exhibitor,
                        field: 'logo',
                        submitCallback: this.fetchExhibitor
                    } }
                >
                    { editor &&
                        <div className="my-8">
                            <PrimaryButton
                                text="Update info, blurb, logo, banner and add video"
                                onClick={ () => null }
                                className="uppercase"
                            />
                        </div>
                    }

                </ModalTrigger>

                {/*{exhibitor.video !== null &&*/}
                {/*    <div className="mt-4 mb-8 px-4 lg:px-16 w-full md:w-2/3 mx-auto">*/}
                {/*        <div className="relative" style={{padding: '56.25% 0 0 0'}}>*/}
                {/*            <iframe*/}
                {/*                className="absolute inset-0 w-full h-full rounded"*/}
                {/*                src={exhibitor.video}*/}
                {/*                frameBorder="0"*/}
                {/*                allow="autoplay; fullscreen; picture-in-picture"*/}
                {/*                allowFullScreen*/}
                {/*            />*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*}*/}
            </>
        );
    }

    /**
     * @method renderCarousel
     * @return {*}
     */
    renderCarousel() {
        const {editor, exhibitor} = this.state;

        return (
            <>
                {editor &&
                    <div className="mt-4 mb-8 text-center">
                        <ModalTrigger
                            component={UpdateCarouselItem}
                            disabled={!editor}
                            props={{
                                exhibitor: exhibitor,
                                carouselItem: null,
                                submitCallback: this.fetchExhibitor
                            }}
                        >
                            <PrimaryButton
                                text="Add Carousel Item"
                                onClick={() => null}
                                className="uppercase"
                            />
                        </ModalTrigger>
                    </div>
                }

                {exhibitor.carousel_items && exhibitor.carousel_items.length > 0 &&
                    <div className="mt-4 mb-8">
                        <Carousel
                            items={exhibitor.carousel_items}
                            arrowColour="text-light-blue-700"
                            perPage="3"
                            thumbnailHeight="120"
                            editor={editor}
                            exhibitor={exhibitor}
                            editorSubmitCallback={this.fetchExhibitor}
                        />
                    </div>
                }
            </>
        );
    }

    /**
     * @method renderQuizArea
     * @return {*}
     */
    renderQuizArea() {
        const {editor, exhibitor, quiz_alert, quiz_working, quiz_answer} = this.state;
        const {active_quiz_questions} = this.state.exhibitor;

        if (editor || (active_quiz_questions && active_quiz_questions.length > 0)) {
            return (
                <div className="w-full md:w-1/2 mx-auto border-4 border-light-blue-700 mt-4 mb-8
                    p-4 bg-white text-center">
                    <div className="mx-auto">
                        <div>
                            <h4 className="font-bold uppercase">
                                {translation('exhibitors', 'quiz_area')}
                            </h4>
                        </div>
                        {editor &&
                            <div className="mt-4">
                                <ModalTrigger
                                    component={UpdateQuizQuestion}
                                    disabled={!editor}
                                    props={{
                                        exhibitor: exhibitor,
                                        quizQuestion: (active_quiz_questions && active_quiz_questions.length > 0) ?
                                            active_quiz_questions[0] :
                                            null,
                                        submitCallback: this.fetchExhibitor
                                    }}
                                >
                                    <PrimaryButton
                                        text={
                                            (active_quiz_questions && active_quiz_questions.length > 0 ? 'Update' : 'Add') +
                                            ' The Quiz Question'}
                                        onClick={() => null}
                                        className="uppercase"
                                    />
                                </ModalTrigger>
                            </div>
                        }
                    </div>
                    <div className="mt-8 mx-auto">
                        {quiz_alert && <Alert {...quiz_alert} />}

                        {active_quiz_questions.map((question, i) => {
                            return (
                                <div key={i}>
                                    {!quiz_alert && question.user_answer &&
                                        <Alert
                                            type='success'
                                            message={question.user_answer_correct ?
                                                translation('exhibitors', 'quiz_submitted_correct') :
                                                translation('exhibitors', 'quiz_submitted_incorrect')}
                                        />
                                    }

                                    <p className="font-bold">
                                        {question.question}
                                    </p>

                                    {question.answers.map((answer, j) => {
                                        return (
                                            <div className="my-4 flex justify-center">
                                                <Radio
                                                    label={null}
                                                    value={quiz_answer ?
                                                        (quiz_answer === answer.key) :
                                                        (question.user_answer ?
                                                            (question.user_answer === answer.key) :
                                                            false)}
                                                    onChange={v => this.setState({'quiz_answer': answer.key})}
                                                />

                                                <p className="mb-0 ml-4 text-sm font-medium leading-5 text-gray-700">
                                                    {answer.value}
                                                </p>
                                            </div>
                                        );
                                    })}

                                    <PrimaryButton
                                        text={question.user_answer ? translation('misc', 'update') : translation('misc', 'submit')}
                                        onClick={() => this.submitQuizAnswer(question.id, quiz_answer)}
                                        disabled={quiz_working}
                                        working={quiz_working}
                                        className="uppercase"
                                    />
                                </div>
                            );
                        })}
                    </div>
                </div>
            );
        }
    };

    /**
     * @method renderBookingArea
     * @return {*}
     */
    renderBookingArea() {
        const {editor, exhibitor} = this.state;
        const {active_booking_items} = this.state.exhibitor;

        if (editor || (active_booking_items && active_booking_items.length > 0)) {
            return (
                <div className="w-full md:w-[22rem] bg-white text-center flex flex-col justify-between h-full">
                    <div className="flex flex-col justify-center md:justify-start items-center md:items-start">
                        { editor && (
                            <div>
                                <ModalTrigger
                                    component={ UpdateBookingItem }
                                    disabled={ !editor }
                                    props={ {
                                        exhibitor: exhibitor,
                                        bookingItem: null,
                                        submitCallback: this.fetchExhibitor
                                    } }
                                >
                                    <PrimaryButton
                                        text="Add Availability"
                                        onClick={ () => null }
                                        className="uppercase my-6"
                                    />
                                </ModalTrigger>
                            </div>
                        ) }
                    </div>

                    <div className="flex flex-col justify-center md:justify-start items-center md:items-start">
                        <ModalTrigger
                            component={ ViewBookings }
                            props={ {
                                active_booking_items: active_booking_items,
                                exhibitor: exhibitor,
                                editing: editor,
                                onclose: this.fetchExhibitor
                            } }
                        >
                            { (User?.data?.first_group_name === 'internal' || User?.data?.first_group_name === 'external' ) && (
                                <DarkButton
                                    text="Book a slot to experience Bodyo’s Health Lounge"
                                    onClick={ () => null }
                                    className="bg-app-light-green text-white"
                                />
                            ) }
                        </ModalTrigger>
                    </div>
                </div>
            );
        }
    }

    /**
     * @method renderTalkArea
     * @return {*}
     */
    renderTalkArea() {
        const { message_alert, message_working, message } = this.state;

        return (
            <div className="w-[22rem] p-4 bg-white flex flex-col justify-between">
                <div className="flex items-center mb-4">
                    <div className="mr-4">
                        <img
                            src={ asset ( "/images/exhibitors/chat-bubble.png" ) }
                            className="h-8"
                        />
                    </div>

                    <div>
                        <h4 className="font-bold uppercase text-left">
                            { translation ( 'exhibitors', 'need_more_information' ) }
                        </h4>
                        <p className="font-light text-left">
                            { translation ( 'exhibitors', 'need_more_information_subtitle' ) }
                        </p>
                    </div>
                </div>

                { message_alert && <Alert { ...message_alert } />}

                <Textarea
                    id="message"
                    onChange={(v) => this.setState({message: v})}
                    value={message}
                    placeholder={translation('exhibitors', 'need_more_information_placeholder')}
                    className="h-72 my-3"
                    border={true}
                />

                <div className="mx-auto">
                    <PrimaryButton
                        text={translation('misc', 'submit')}
                        onClick={() => this.sendMessage()}
                        className="uppercase"
                        working={message_working}
                        disabled={message_working}
                    />
                </div>
            </div>
        );
    }

    /**
     * @method renderDownloadsArea
     * @return {*}
     */
    renderDownloadsArea() {
        const {editor, exhibitor} = this.state;
        const {downloads} = this.state.exhibitor;

        if (editor || (downloads && downloads.length > 0)) {
            return (
                <div className="w-full  p-4 bg-app-gray text-center sm:text-left">
                    <div className="flex items-center">
                        <p className="font-bold text-app-blue text-center">
                            {translation('exhibitors', 'downloads')}
                        </p>

                        {editor &&
                            <div className="ml-4">
                                <ModalTrigger
                                    component={UpdateDownload}
                                    disabled={!editor}
                                    props={{
                                        exhibitor: exhibitor,
                                        download: null,
                                        submitCallback: this.fetchExhibitor
                                    }}
                                >
                                    <PrimaryButton
                                        text="Add"
                                        onClick={() => null}
                                        className="uppercase"
                                    />
                                </ModalTrigger>
                            </div>
                        }
                    </div>
                    <div className="3 flex flex-col justify-center">
                        {downloads.map((download, i) => {
                            return (
                                <div className="flex items-center my-3" key={i}>
                                    <div className="mr-4">
                                        <img src={asset("/images/exhibitors/pdf.png")} className="w-10" />
                                    </div>
                                    <div>
                                        {download.action === 'download' &&
                                            <a
                                                className="text-app-blue"
                                                href={download.src.url}
                                                download
                                                target="_blank"
                                            >
                                                {download.name}
                                            </a>
                                        }
                                        {download.action === 'open' &&
                                            <a
                                                className="text-app-blue"
                                                href={download.src.url}
                                                target="_blank"
                                            >
                                                {download.name}
                                            </a>
                                        }
                                    </div>
                                    {editor &&
                                        <div className="ml-4">
                                            <ModalTrigger
                                                component={UpdateDownload}
                                                disabled={!editor}
                                                props={{
                                                    exhibitor: exhibitor,
                                                    download: download,
                                                    submitCallback: this.fetchExhibitor
                                                }}
                                            >
                                                <PrimaryButton
                                                    text="Update"
                                                    onClick={() => null}
                                                    className="uppercase"
                                                />
                                            </ModalTrigger>
                                        </div>
                                    }
                                </div>
                            );
                        })}
                    </div>
                </div>
            );
        }

        //return empty
        return (
            <></>
        );
    }

}
